import lodash from "lodash";
import React from "react";
import { TIPTAP_EMBED_TYPE, TIPTAP_LINK_PREVIEW_TYPE } from "./../ricos-content/index.js";
import { Node_Type } from "./../ricos-types/index.js";
import { PLUGIN_TOOLBAR_SETTINGS_BUTTON } from "./../_shared/data-hooks.js";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./../editor-common/index.js";
import { selectedNodeResolver } from "./../plugin-commons/index.js";
import { UrlLinkButton } from "./../plugin-link/toolbar/url-link-button.js";
import {
  getUrlLinkFromLinkPreview,
  isEmbedNode,
  isLinkPreviewContainsLink,
  isLinkPreviewNode
} from "./../toolbars-v3/resolvers/tiptapResolvers.js";
import { FLOATING_PLUGIN_TOOLBAR } from "./../toolbars-v3/ricos-toolbars/index.js";
import { linkPreviewModals } from "./consts.js";
import {
  PLUGIN_TOOLBAR_GO_TO_LINK_BUTTON,
  PLUGIN_TOOLBAR_REPLACE_TO_LINK_BUTTON,
  PLUGIN_TOOLBAR_UNLINK_BUTTON
} from "./data-hooks.js";
import { SettingsModal } from "./modals/SettingsModal.js";
import { DisplayAsUrlButton } from "./toolbar/DisplyAsUrlButton.js";
import { UnlinkButton } from "./toolbar/UnlinkButton.js";
const isLinkPreviewSelectedResolver = {
  id: "isLinkPreviewSelected",
  resolve: (content) => {
    if (Array.isArray(content) && content.length > 0) {
      return content[0].type?.name === TIPTAP_LINK_PREVIEW_TYPE;
    } else {
      return false;
    }
  }
};
const getToolbarButtons = (config, services) => {
  const { modals } = services;
  return [
    {
      id: "urlLink",
      type: "toggle",
      dataHook: PLUGIN_TOOLBAR_GO_TO_LINK_BUTTON,
      attributes: {
        selectedUrlLinkData: getUrlLinkFromLinkPreview,
        visible: isLinkPreviewContainsLink,
        selectedNode: selectedNodeResolver
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(UrlLinkButton, { toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: isLinkPreviewContainsLink
      }
    },
    {
      id: `${Node_Type.LINK_PREVIEW}.replace`,
      dataHook: PLUGIN_TOOLBAR_REPLACE_TO_LINK_BUTTON,
      command: ({ tiptapEditor, attributes: { selectedNode } }) => {
        const link = selectedNode.type.name === TIPTAP_EMBED_TYPE ? selectedNode.attrs.src : selectedNode.attrs.link.url;
        tiptapEditor.chain().focus().setMeta("allowTextReplace", true).insertContent(link + " ").run();
      },
      attributes: {
        selectedNode: selectedNodeResolver
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(DisplayAsUrlButton, { toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
      dataHook: PLUGIN_TOOLBAR_SETTINGS_BUTTON,
      command: ({ isMobile, referenceElement, attributes: { selectedNode } }) => {
        const isModalOpen = modals.isModalOpen(linkPreviewModals.settings);
        isModalOpen ? modals.closeModal(linkPreviewModals.settings) : modals.togglePluginPanel({
          id: linkPreviewModals.settings,
          Component: SettingsModal,
          componentProps: {
            referenceElement,
            nodeId: selectedNode.attrs.id,
            activeTab: "settings",
            config
          },
          positioning: {
            referenceElement: referenceElement.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ?? referenceElement,
            placement: "right-start"
          },
          onClickOutside: {
            on: "pointerup",
            handler: lodash.noop
          },
          focusReturnElement: referenceElement,
          isMobile
        });
      },
      attributes: {
        selectedNode: selectedNodeResolver,
        visible: isLinkPreviewSelectedResolver,
        active: {
          id: "IS_LINK_PREVIEW_SETTINGS_BUTTON_ACTIVE",
          resolve: (_, { modals: modals2 }) => {
            return Boolean(modals2.getModal(linkPreviewModals.settings));
          }
        }
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: isLinkPreviewNode
      }
    },
    {
      id: `${Node_Type.LINK_PREVIEW}.unlink`,
      dataHook: PLUGIN_TOOLBAR_UNLINK_BUTTON,
      command: ({ tiptapEditor, attributes: { selectedNode } }) => {
        const link = selectedNode.type.name === TIPTAP_EMBED_TYPE ? selectedNode.attrs.src : selectedNode.attrs.link.url;
        const { state } = tiptapEditor;
        const { selection } = state;
        const from = selection.from;
        tiptapEditor.chain().focus().setMeta("allowTextReplace", true).insertContent(link + " ").setTextSelection({ from, to: from + link.length + 1 }).run();
        tiptapEditor.chain().unsetLink().run();
      },
      attributes: {
        selectedNode: selectedNodeResolver,
        visible: isLinkPreviewNode
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(UnlinkButton, { toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE,
      attributes: { visible: isEmbedNode }
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
